export default "__VITE_ASSET__CEte152b__"